import { render } from "./TooltipContent.vue?vue&type=template&id=9b1ab982&ts=true"
import script from "./TooltipContent.vue?vue&type=script&lang=ts"
export * from "./TooltipContent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/barry/www/my/www/bi/portal-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__